export const NEWCLICK_SERVICES_BASE_URL = '/services';
